import { render } from "./FormEditCompanyTertiary.vue?vue&type=template&id=3425c467"
import script from "./FormEditCompanyTertiary.vue?vue&type=script&lang=js"
export * from "./FormEditCompanyTertiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__